<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
        :maximizable="true"

    >
      <template #header>
        <i style=" transform: scale(1.7); " class="pi pi-id-card"></i>
        <h1>הוספת משתמש</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>שם פרטי</label>

          <InputText type="text" v-model="newItem.firstname" autofocus/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="lastname6">שם משפחה</label>
          <InputText id="lastname6" type="text" v-model="newItem.lastname"/>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label>סיסמא</label>
          <InputText type="text" v-model="newItem.password"/>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label>תעודת זהות</label>
          <InputNumber type="decimal" v-model="newItem.id"/>
        </div>

        <div class="p-field p-col-12 p-md-3">
          <label>כמות דיווחים</label>
          <InputNumber type="decimal" v-model="newItem.amountReports"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>כיתה</label>
          <!-- ** -->

          <!-- ** -->
          <Dropdown
              :showClear="true"
              v-model="newItem.grade"
              :options="gradeOptions"
              placeholder="בחר כיתה"
          >
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ slotProps.value.hebrewName }}</span>
              </div>
              <span v-else>
                {{ slotProps.placeholder }}
              </span>
            </template>
            <template #option="slotProps">
              <span>{{ slotProps.option.hebrewName }}</span>
            </template>
          </Dropdown>
        </div>

        <div class="p-field p-col-12 p-md-3">
          <label>הרשאה</label>

          <Dropdown v-model="newItem.role" :options="roles">
            <template #option="slotProps">
              <span>{{ getRoleLabel(slotProps.option) }}</span>
            </template>
            <template #value="slotProps">
              <div v-if="slotProps.value">
                <span>{{ getRoleLabel(newItem.role) }}</span>
              </div>
              <span v-else> בחר הרשאה </span>
            </template>
          </Dropdown>
        </div>
      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
    </div>
</template>

<script>
import Service from "../service/Service";
import {mapState} from "vuex";

export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {
    this.service = new Service();
    this.setNewItwmFields();
  },
  computed: {
    ...mapState(["gradeOptions"]),
  },
  data() {
    return {
      newItem: null,
      roles: ["USER", "MIKTZOI", "ADMIN"],
    };
  },

  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: null,
        password: null,
        firstname: null,
        lastname: null,
        role: "USER",
        amountReports: null,
        enabled: true,
        grade: null,
      };
    },
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "NA";
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
      let validate = true;
      for (const key in this.newItem) {
        if (this.newItem.id === null) {
          validate = false;
        }
      }

      if (validate === true) {
        const userObj = JSON.parse(JSON.stringify(this.newItem))
        if (this.newItem.grade) {
          const gradeObj = JSON.parse(JSON.stringify(this.newItem.grade))
          userObj.grade = userObj.grade.id
        }

        await this.service
            .post(userObj, 'user')
            .then(() => {
              if (this.newItem.grade) {
                userObj.grade = gradeObj;
              }
              this.$emit("addItem", userObj);
              this.setNewItwmFields();
              this.openNotification(
                  "success",
                  `מעולה`,
                  `המשתמש התתוסף במערכת`
              );
              this.closeDialog();
            })
            .catch(() => {
              this.openNotification(

                  "danger",
                  `אופס`,
                  `אולי קיים כבר משתמש עם ת.ז. זהה`
              );
            });
      } else {
        this.openNotification(
            "danger",
            `אופס`,
            `חסרים כמה שדות למילוי`
        );
      }
    },
    openNotification(
        color,
        title,
        text,
        position = "right-left",
        duration = 3000
    ) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
.p-dialog .p-dialog-footer {
  text-align: left !important;
}
</style>